import React from 'react';
import { theme } from '../theme/theme';

const Card = ({
  children,
  elevation = 1,
  padding = 'lg',
  style = {},
  ...props
}) => {
  const getCardStyles = () => {
    const baseStyles = {
      background: theme.colors.background.paper,
      borderRadius: theme.borderRadius.lg,
      boxShadow: theme.shadows[`sm${elevation}`],
      transition: `box-shadow ${theme.transitions.default}`,
      overflow: 'hidden',
      ...style
    };

    const paddingStyles = {
      none: {},
      sm: { padding: theme.spacing.sm },
      md: { padding: theme.spacing.md },
      lg: { padding: theme.spacing.lg },
      xl: { padding: theme.spacing.xl }
    };

    return {
      ...baseStyles,
      ...paddingStyles[padding]
    };
  };

  return (
    <div style={getCardStyles()} {...props}>
      {children}
    </div>
  );
};

export default Card; 